"use client";

import { useSearchContext } from "@/components/_Search/provider/SearchContextProvider";
import styles from "@/components/_Search/UI/SortAndFilter/FilterAndSort.module.scss";
import SelectInput from "@/components/UI/Input/SelectInput/SelectInput";
import { useScopedI18n } from "@/i18n/client";
import { FC } from "react";

const SortBy: FC = () => {
	const t = useScopedI18n("FilterAndSort");
	const { sortBy } = useSearchContext();

	const inputOptions = sortBy.options.map((option) => {
		const key = `sortBy.options.${option.value}` as keyof typeof t;

		let label = t(key);

		if (label === key) {
			label = option.label;
		}

		return {
			text: label,
			value: option.value,
		};
	});

	const handleOnChange = (value: string) => {
		sortBy.setValue(value);
	};

	const label = t("sortBy.label");

	return (
		<SelectInput
			label={label}
			placeHolder={label}
			options={inputOptions}
			value={sortBy.value?.value || sortBy.default?.value || undefined}
			prefix={`${label}: `}
			onChange={handleOnChange}
			className={styles.field}
		/>
	);
};

export default SortBy;
